module.exports = __webpack_public_path__ + "img/theme-6-black.06d802ed.svg";